(function () {
  "use strict";

  EditGroupUsersSidebarCtrl.$inject = ['$scope', 'groupsResource', 'usersResource', 'sortHelper'];
  angular
    .module('trainerWebApp.controllers')
    .controller('EditGroupUsersSidebarCtrl', EditGroupUsersSidebarCtrl);

  function EditGroupUsersSidebarCtrl($scope, groupsResource, usersResource, sortHelper) {
    var changes = {};
    var removeAction = 1;
    var addAction = 2;

    $scope.serverCallInProgress = false;
    $scope.allUsers = [];
    $scope.allGroups = [];

    var select2AllUsers = [];
    var select2AllGroups = [];

    getAllUsers();

    function allUsersQuery(query) {
      query.callback({
        results: getAllUsersAndGroups(query.term)
      });
    }

    function getAllUsersAndGroups(term) {
      var users = [];
      var groups = [];

      if (term && term.length !== 0) {
        var termLower = term.toLowerCase();

        users = _.filter(select2AllUsers, function (item) {
          return item.text.toLowerCase().indexOf(termLower) >= 0;
        });

        groups = _.filter(select2AllGroups, function (item) {
          return item.text.toLowerCase().indexOf(termLower) >= 0;
        });
      } else {
        users = select2AllUsers;
        groups = select2AllGroups;
      }

      var ids = _.pluck($scope.groupUsers, 'id');


      var result = [];

      var filteredUsers = _.filter(users, function (u) {
        return !_.contains(ids, u.id);
      });

      if (filteredUsers.length > 0) {
        result.push({
          text: "Users",
          children: filteredUsers
        });
      }

      if (groups.length > 0) {
        result.push({
          text: "Groups",
          children: groups
        });
      }

      return result;
    }

    $scope.selectUsersOptions = {
      width: '100%',
      multiple: true,
      query: allUsersQuery,
      minimumInputLength: 0,
      maximumInputLength: 40,
      allowClear: true,
      dropdownCssClass: "select2-dropdown-size-hack select2-short-dropdown"
    };

    function getAllUsers() {
      usersResource.getUsers(function (result) {
        $scope.allUsers = result;

        select2AllUsers = _.map(_.filter($scope.allUsers, function (user) {
          return user.status == 109000200;
        }), function (value) {
          return buildUser(value);
        }).sort(sortHelper.getStringPropertySorter({field: 'text', asc: true}));
      });

      groupsResource.getGroups(function (result) {
        $scope.allGroups = _.filter(result, function (g) {
          return g.id != $scope.selectedGroup.id;
        });

        select2AllGroups = _.map($scope.allGroups, function (item) {
          return buildGroup(item);
        }).sort(sortHelper.getStringPropertySorter({field: 'text', asc: true}));
      });
    }

    function buildUser(item) {
      return {
        id: item.id,
        text: _.escape(item.lastName) + ', ' + _.escape(item.firstName),
        type: 'user'
      };
    }

    function buildGroup(item) {
      return {
        id: item.id,
        text: _.escape(item.name) + " (" + item.userCount + ")",
        type: 'group'
      };
    }

    $scope.groupUsers = $scope.selectedGroup.groupUsers;

    $scope.viewModel = {
      selectedUsers: $scope.groupUsers
    };

    $scope.selectGroupsOptions = {
      closeOnSelect: false,
      maximumInputLength: 40
    };

    $scope.cancelChanges = function () {
      clean();
      $scope.changeSidebar('pages/group/groupDetailSidebar.html');
    };

    $scope.applyChanges = function () {
      var changesList = _.pairs(changes);
      var groupId = $scope.selectedGroup.id;
      var saveData = {groupId: groupId, addUserIds: [], removeUserIds: []};

      _.each(changesList, function (pair) {
        var userId = pair[0];
        var action = pair[1];
        if (action == addAction) {
          saveData.addUserIds.push(userId);
        }
        else {
          saveData.removeUserIds.push(userId);
        }
      });

      $scope.serverCallInProgress = true;
      groupsResource.updateGroupUsers(saveData, function (res) {
        $scope.refreshData();
        $scope.serverCallInProgress = false;
        $scope.manageGroupsEditors.editGroupUsersSidebarDirty = false;
        $scope.changeSidebar('pages/group/groupDetailSidebar.html');
      });
    };

    function clean() {
      $scope.manageGroupsEditors.editGroupUsersSidebarDirty = false;
      $scope.serverCallInProgress = false;
    }

    function markDirty() {
      $scope.manageGroupsEditors.editGroupUsersSidebarDirty = true;
    }

    $scope.canApplyChanges = function () {
      return $scope.manageGroupsEditors.editGroupUsersSidebarDirty && !$scope.serverCallInProgress;
    };

    $scope.remove = function (userId) {
      var currentAction = changes[userId];
      if (currentAction == addAction) {
        delete changes[userId];
      }
      else if (!currentAction) {
        changes[userId] = removeAction;
      }

      $scope.groupUsers = _.reject($scope.groupUsers, function (u) {
        return u.id == userId;
      });
      markDirty();
      if ($scope.forceCloseDropDown)
        $scope.forceCloseDropDown();
    };

    $scope.addUser = function (item, cb) {
      if (item.type == 'user') {
        addUser(item.id);

        var user = _.find(select2AllUsers, function (u) {
          return u.id == item.id;
        });

        $scope.groupUsers.push({id: user.id, name: user.text});
        markDirty();
        if (cb) {
          cb(false);
        }
      } else {
        groupsResource.getGroupUsers(item.id, function (res) {
          var newIds = _.pluck(res, 'id');
          var existingIds = _.pluck($scope.groupUsers, 'id');
          var usersToAdd = _.difference(newIds, existingIds);
          var users = _.filter(res, function (u) {
            return _.contains(usersToAdd, u.id);
          });

          _.each(users, function (user) {
            addUser(user.id);
            $scope.groupUsers.push({id: user.id, name: user.lastName + ', ' + user.firstName});
          });

          markDirty();
          if (cb) {
            cb(false);
          }
        });
      }

      if ($scope.forceCloseDropDown)
        $scope.forceCloseDropDown();
    };

    function addUser(id) {
      var currentAction = changes[id];
      if (currentAction == removeAction) {
        delete changes[id];
      } else if (!currentAction) {
        changes[id] = addAction;
      }
    }
  }

})();
